<script>
import Evaluate from '@/core/evaluate/evaluate';
import { evaluate, getRecycleNum } from '@/apis/base';
import { Button as hButton } from 'hsb_recycle_components';
import { Toast } from 'mint-ui';
import productInfo from '@/core/evaluate/product-info';

export default {
  components: {
    Evaluate,
    hButton,
    productInfo
  },
  props: {
    selecteds: String
  },
  data () {
    return {
      loading: false,
      selects: [],
      recycleNum: 0
    };
  },
  computed: {
    requiredLen () {
      return this.params.itemList && this.params.itemList.filter(item => item.conftype !== '3').length;
    },
    isCompleted () {
      return this.selects.length >= this.requiredLen;
    },
    params () {
      return this.$store.state.productParam.params;
    },
    productId () {
      return this.params.productId;
    },
    loaded () {
      return this.params.productName;
    }
  },
  methods: {
    reselect () {
      this.$router.push('/products');
    },
    async getRecycleNum () {
      try {
        const res = await getRecycleNum(this.productId);

        if (res.success) {
          this.recycleNum = res._data.recycleNum;
        }
      } catch (err) {
        return;
      }
    },
    async submit () {
      if (!this.isCompleted) {
        return;
      }
      this.loading = true;
      let res = null;
      try {
        res = await evaluate(this.productId, JSON.stringify(this.selects));
      } catch (err) {
        res = {
          _errStr: 'evalute err .'
        }
      }
      if (!res || +res._errCode !== 0) {
        this.loading = false;
        Toast(res._errStr);
        return;
      }
      setTimeout(() => {
        this.loading = false;
      }, 3000);
      this.$router.push({
        name: 'EvInfo',
        params: {
          evID: res._data.evaluateid
        },
        query: {
          selecteds: JSON.stringify(this.selects)
        }
      });
    },
    init () {
      this.getRecycleNum();
      const selecteds = this.$route.query.selecteds;
      if (!selecteds) {
        return;
      }
      try {
        this.selects = JSON.parse(selecteds);
      } catch (err) {
        return;
      }
    }
  },
  beforeMount () {
    this.init();
  }
};
</script>
